import Vue from 'vue';
import querystring from 'querystring';
import * as Articulos from '@lib/Articulos';
import * as Pagos from '@lib/Ventas/Pagos';
import { Pago } from '@lib/Ventas/Pagos';
import { Watch } from 'vue-property-decorator';
import { Paginacion, Wait } from '@/__env/ext';
import { Utiles } from '@env/pluggins/event-bus';
import { SignalDispatcher } from 'strongly-typed-events';
import { VistaBase, FiltrosBase } from '@/components/a-interfaz/a-controlador';
import router from '@/__env/router.index';
import { CuentasMercadoLibre } from '@/__env/lib/MercadoLibre/Cuentas/Cuentas';


export class ControladorSeccion
{

    public readonly Buscador: Buscador = new Buscador();
    public Seleccionados: Pago[] = [];

    Iniciar()
    {
        this.Buscador.Iniciar();
    }


    Abrir( x: Pago )
    {
        if ( x && x.Existe )
        {
            router.push( '/mercadolibre/publicacion/' + x.Id );
        }
    }

    AbrirPedido( x: number)
    {
        if ( x )
        {
            window.open( '/#/pedido/' + x );
        }
    }

    public Vista: Vista = new Vista();
    private _onSeleccionados = new SignalDispatcher();
    public get onSeleccionados() { return this._onSeleccionados.asEvent(); }

    public RecargarEstadistica()
    {
        this._onRecargarEstadistica.dispatch();
    }
    private _onRecargarEstadistica= new SignalDispatcher();
    public get onRecargarEstadistica() { return this._onRecargarEstadistica.asEvent(); }
}

export class Vista
{
    public Filtros: FiltrosBase = new FiltrosBase();

    protected modo: string = 'resumen';
    get Modo(): string { return this.modo; }
    set Modo( m: string ) { this.modo = m; this._onModo.dispatch(); }
    private _onModo = new SignalDispatcher();
    public get onModo() { return this._onModo.asEvent(); }
}

type Estado = 'cargando' | 'vacio' | 'ok' | 'error';
export class Buscador
{

    public Items: Pago[] = [];

    public Filtros: Filtros = new Filtros( this );
    Iniciar()
    {
        this.Filtros = new Filtros( this );
    }

    protected estado: Estado = 'cargando';
    get Estado(): Estado { return this.estado; }
    set Estado( m: Estado ) { this.estado = m; this._onEstado.dispatch(); }
    private _onEstado = new SignalDispatcher();
    public get onEstado() { return this._onEstado.asEvent(); }

    private _onActualizar = new SignalDispatcher();
    public get onActualizar() { return this._onActualizar.asEvent(); }

    public Paginacion: Paginacion;

    public async Buscar( pagina: number = null, agregar: boolean = false )
    {
        if ( pagina )
            this.Filtros.Valores.Pagina = pagina;

        if ( !agregar )
        {
            this.Items.clear();
            this.Estado = 'cargando';
        }

        Utiles.setQuery( this.Filtros.get() );
        this._onActualizar.dispatch();


        await Wait( 100 );
        let ff = this.Filtros.Obtener();
        ff.plataforma = 'mercadopago';
        let e = await Pago.find(ff);
        if ( e.Error )
            this.Estado = 'error';
        else
        {
            if ( !agregar )
            {
                this.Items = e.Items;
            } else
            {
                this.Items.push( ...e.Items );
            }

            this.Paginacion = e.Paginacion;
            if ( this.Items.hasRows() )
                this.Estado = 'ok';
            else
                this.Estado = 'vacio';
        }

        this._onActualizar.dispatch();
    }
}

export class Filtros
{
    constructor( b: Buscador )
    {
        this.Buscador = b;
    }

    public Buscador: Buscador;
    public Busqueda: string = '';

    public Valores: Record<string, any> = {
        Estado: 2,
        Tipo: 1,
        Metodo: 0,
        TiposArticulo: 0,
        Limite: 1,
        Orden: 0,
        Indice: 0,
        Cuenta: 0,
        Pagina: 1,
        Tag: 0,
        EnvioGratis: 0,
    };


    public get Estados() { return Pagos.Estados.Filter; }
    public get Tipos() { return [{ Nombre: 'Todos', Id: '' }, { Nombre: 'Ingreso', Id: 'N' }, { Nombre: 'Egreso', Id: 'S' }]; }
    public get Metodos() { return Pagos.Tipos.Filter; }
    public get Cuentas() { return [...CuentasMercadoLibre]; }
    public get Limites() { return [{ Nombre: '5', Id: 5 }, { Nombre: '10', Id: 10 }, { Nombre: '20', Id: 20 }, { Nombre: '50', Id: 50 }]; }
    public get Ordenes() { return [{ Nombre: 'Descendente', Id: 'DESC' }, { Nombre: 'Ascendente', Id: 'ASC' }]; }
    public get Indices() { return [{ Nombre: 'Fecha', Id: 'fecha_creacion' }, { Nombre: 'Id', Id: 'id' }, { Nombre: 'Importe', Id: 'importe_pagado' }]; }
    public get Tags()
    {
        return [
            { Nombre: 'Todos', Id: '' },
            { Nombre: 'Error en codigo', Id: 'error_en_codigo', Valor: 'error_en_codigo' },
            { Nombre: 'Disponibles para reactivar', Id: 'disponible_para_reactivar', Valor: 'disponible_para_reactivar' },
            { Nombre: 'Pausadas por faltante', Id: 'pausado_por_faltante', Valor: 'pausado_por_faltante' },
        ];
    }

    public get Activos(): { Nombre: string, Eliminar: any; }[]
    {
        let a: { Nombre: string, Eliminar: any; }[] = [];

        if ( this.Busqueda )
        {
            a.push( { Nombre: `Resultados para: ${this.Busqueda}`, Eliminar: () => { this.Busqueda = ''; this.Buscador.Buscar(); } } );
        }
        else
        {

            if ( this.Valores.Estado > 0 )
            {
                a.push( { Nombre: this.Estados[this.Valores.Estado].Nombre, Eliminar: () => { this.Valores.Estado = 0; this.Buscador.Buscar(); } } );
            }

            if ( this.Valores.Tag > 0 )
            {
                a.push( { Nombre: this.Tags[this.Valores.Tag].Nombre, Eliminar: () => { this.Valores.Tag = 0; this.Buscador.Buscar(); } } );
            }

            if ( this.Valores.Metodo > 0 )
            {
                a.push( { Nombre: this.Metodos[this.Valores.Metodo].Nombre, Eliminar: () => { this.Valores.Metodo = 0; this.Buscador.Buscar(); } } );
            }


            if ( this.Valores.Tipo > 0 )
            {
                a.push( { Nombre: this.Tipos[this.Valores.Tipo].Nombre, Eliminar: () => { this.Valores.Tipo = 0; this.Buscador.Buscar(); } } );
            }


            if ( this.Valores.Cuenta  > 0)
            {
                a.push( { Nombre: this.Cuentas[this.Valores.Cuenta].Nombre, Eliminar: () => { this.Valores.Cuenta = 0; this.Buscador.Buscar(); } } );
            }
        }

        return a;
    }

    public Obtener(): any
    {
        let filtro: any = {};
        filtro.busqueda = 'S';
        if ( this.Busqueda )
        {
            filtro.q = this.Busqueda;
        }
        else
        {

            if ( this.Valores.Estado > 0 )
            {
                filtro.estado = this.Estados[this.Valores.Estado].Valor.map( x => x.Id ).join( ',' );
            }



            if ( this.Valores.Tag > 0 )
            {
                filtro.tags = this.Tags[this.Valores.Tag].Id;
            }



            if ( this.Valores.Metodo > 0 )
            {
                filtro.tipo = this.Metodos[this.Valores.Metodo].Valor.map( x => x.Id ).join( ',' );
            }

            if ( this.Valores.Tipo > 0 )
            {
                filtro.propio = this.Tipos[this.Valores.Tipo].Id;
            }



            if ( this.Valores.Cuenta > 0 )
            {
                filtro.cuenta = this.Cuentas[this.Valores.Cuenta].Id;
            }

        }

        if ( this.Valores.Limite >= 0 )
        {
            filtro.limit = this.Limites[this.Valores.Limite].Id;
        }

        if ( this.Valores.Orden >= 0 )
        {
            filtro.sort = this.Ordenes[this.Valores.Orden].Id;
        }

        if ( this.Valores.Indice >= 0 )
        {
            filtro.order = this.Indices[this.Valores.Indice].Id;
        }

        if ( this.Valores.Pagina > 0 )
        {
            filtro.page = this.Valores.Pagina;
        }

        return filtro;
    }

    public set( filtro: any )
    {

        if ( filtro.q )
        {
            this.Busqueda = String( filtro.q );
        }

        if ( filtro.estado )
        {
            this.Valores.Estado = 0;
            let idx = this.Estados.findIndex( x => x.Nombre.eliminar( ' ' ).toLowerCase() == filtro.estado );
            if ( idx > 0 ) this.Valores.Estado = idx;
        }

        if ( filtro.estado )
        {
            this.Valores.Tag = 0;
            let idx = this.Tags.findIndex( x => x.Nombre.eliminar( ' ' ).toLowerCase() == filtro.tag );
            if ( idx > 0 ) this.Valores.Tag= idx;
        }

        if ( filtro.tipo )
        {
            this.Valores.Metodo = 0;
            let idx = this.Metodos.findIndex( x => x.Nombre.toLowerCase().eliminar( ' ' ) == filtro.tipo );
            if ( idx > 0 ) this.Valores.Metodo = idx;
        }

        if ( filtro.propio )
        {
            this.Valores.Tipo = 0;
            let idx = this.Tipos.findIndex( x => x.Nombre.toLowerCase().eliminar( ' ' ) == filtro.propio );
            if ( idx > 0 ) this.Valores.Tipo = idx;
        }



        if ( filtro.cuenta )
        {
             this.Valores.Cuenta = 0;
            let idx = this.Cuentas.findIndex( x => x.Id == filtro.cuenta );
            if ( idx > 0 ) this.Valores.Cuenta = idx;
        }

        if ( filtro.limit )
        {
            this.Valores.Limite = 1;
            let idx = this.Limites.findIndex( x => x.Id == filtro.limit );
            if ( idx > 0 ) this.Valores.Limite = idx;
        }

        if ( filtro.sort )
        {
            this.Valores.Orden = 0;
            let idx = this.Ordenes.findIndex( x => x.Id == filtro.sort );
            if ( idx > 0 ) this.Valores.Orden = idx;
        }

        if ( filtro.order )
        {
            this.Valores.Indice = 0;
            let idx = this.Indices.findIndex( x => x.Id == filtro.order );
            if ( idx > 0 ) this.Valores.Indice = idx;
        }

        if ( filtro.page > 0 )
        {
            this.Valores.Pagina = filtro.page;
        }

    }

    public get(): string
    {
        let filtro: any = {};
        if ( this.Busqueda )
        {
            filtro.q = this.Busqueda;
        }

        if ( this.Valores.Estado > 0 )
        {
            filtro.estado = this.Estados[this.Valores.Estado].Nombre.eliminar( ' ' ).toLowerCase();
        }

        if ( this.Valores.Tag > 0 )
        {
            filtro.tag = this.Tags[this.Valores.Tag].Nombre.eliminar( ' ' ).toLowerCase();
        }

        if ( this.Valores.Cuenta > 0 )
        {
            filtro.cuenta = this.Cuentas[this.Valores.Cuenta].Id;
        }

        if ( this.Valores.Metodo > 0 )
        {
            filtro.tipo = this.Metodos[this.Valores.Metodo].Nombre.eliminar( ' ' ).toLowerCase();
        }

        if ( this.Valores.Tipo > 0 )
        {
            filtro.propio = this.Tipos[this.Valores.Tipo].Nombre.eliminar( ' ' ).toLowerCase();
        }


        if ( this.Valores.Limite >= 0 )
        {
            filtro.limit = this.Limites[this.Valores.Limite].Id;
        }

        if ( this.Valores.Orden >= 0 )
        {
            filtro.sort = this.Ordenes[this.Valores.Orden].Id;
        }

        if ( this.Valores.Indice >= 0 )
        {
            filtro.order = this.Indices[this.Valores.Indice].Id;
        }

        if ( this.Valores.Pagina > 0 )
        {
            filtro.page = this.Valores.Pagina;
        }


        return querystring.encode( filtro );
    }
}

const Controlador = new ControladorSeccion();
export { Controlador };

